const localeLength = 2;
const startIndexForVSTF = 22;
const startIndexForSMART = 24;
const english = 'English';
const marathi = 'Marathi';
const SMART = 'smart-mh';
const VSTF = 'mvstf';

class LocaleService {
    constructor() {

    }
    getCurrentLocale() {
        let location = window.parent.location.toString();

        if(location.indexOf(SMART) !== -1){
            let lang = window.parent.location.toString().substr(startIndexForSMART,localeLength);
            return lang === 'en'? english:marathi;
        }else if(location.indexOf(VSTF) !== -1) {
            let lang = window.parent.location.toString().substr(startIndexForVSTF,localeLength);
            return lang === 'en'? english:marathi;
        }

        
        // if (location.indexOf('en') !== -1) {
        //     return english;
        // } else if (location.indexOf('mr') !== -1) {
        //     return marathi;
        // } else {
        //     return english;
        // }
    }
}

export default LocaleService;


// WEBPACK FOOTER //
// ./src/services/localeService.js